import styled from 'styled-components'

export const FooterAdWrapper = styled.div`
  /* margin-top: auto; */
`

export const Wrapper = styled.div`
  padding-top: 30px;
`
